import { render, staticRenderFns } from "./Stubbable.vue?vue&type=template&id=578d76fa&scoped=true&"
import script from "./Stubbable.vue?vue&type=script&lang=js&"
export * from "./Stubbable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578d76fa",
  null
  
)

export default component.exports